import React, { useState, useEffect } from 'react';
import '../Styles/Home.css'; // 引入動畫樣式

function FinanceResearch() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 頁面動畫載入效果
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className={`page-container ${isLoaded ? 'content-loaded' : 'content-hidden'}`}>
      <h1 className={`${isLoaded ? 'fade-in-element' : ''}`}>Finance Research</h1>
      <p className={`${isLoaded ? 'fade-in-element delay-1' : ''}`}>Welcome to the Finance Research section. Here you can explore various financial research topics including Equity Research and M&A Analysis.</p>
      
      <div className={`research-sections ${isLoaded ? 'fade-in-element delay-2' : ''}`}>
        <div className="research-section">
          <h2 className={`${isLoaded ? 'fade-in-element delay-2' : ''}`}>Equity Research</h2>
          <p className={`${isLoaded ? 'fade-in-element delay-3' : ''}`}>Explore in-depth analysis of stocks, sectors, and market trends.</p>
          <a href="/equity-research" className={`research-link ${isLoaded ? 'fade-in-element delay-3' : ''}`}>View Equity Research</a>
        </div>
        
        <div className="research-section">
          <h2 className={`${isLoaded ? 'fade-in-element delay-2' : ''}`}>M&A Analysis</h2>
          <p className={`${isLoaded ? 'fade-in-element delay-3' : ''}`}>Discover insights on mergers, acquisitions, and corporate restructuring.</p>
          <a href="/ma-analysis" className={`research-link ${isLoaded ? 'fade-in-element delay-3' : ''}`}>View M&A Analysis</a>
        </div>
      </div>
    </div>
  );
}

export default FinanceResearch;
